<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import FamilyForm from "../../../components/personnel/family/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": FamilyForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('recfamdetails.createfamdetails'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        pic: null,
        membername: null,
        membertypeid: null,
        dob: null,
        salutid: null,
        genderid: null,
        marstatid: null,
        icno: null,
        refno: null,
        isSpouse: null,
        isHandicap: null,
        isWorking: null,
        employername: null,
        compnyaddr: null,
        empcontactinfo: null,
        isStudying: null,
        edulevelid: null,
        instid: null,
        isOversea: null,
        startdate: null,
        enddate: null,
        attach: null,
        remark: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      salutationList: [],
      genderList: [],
      marStatList: [],
      edulevelList: [],
      instList: [],
      staffList: [],
      compnyList: [],
      membertypeList: [],
      staffidList: [],

      salutations: [],
      genders: [],
      marStats: [],
      edulevels: [],
      insts: [],
      staffs: [],
      membertypes: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/family/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "familylist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "familylist" });
    },
  },
};
</script>